import validationRules from '@/assets/validationRules.json';

export default {
  data() {
    return {
      validationRules: validationRules,
    };
  },
};
